// UserQuestionaireOnboarding.jsx

import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
} from '@mui/material';
import UserQuestionnaireOnboardingStyles from './UserQuestionnaireOnboarding.styles';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth'; 
import { useUserOnboarding } from '../../../hooks/useUserOnboarding'; 

const UserQuestionnaireOnboarding = () => {
  const [formData, setFormData] = useState({
    section8Participation: '',
    leaseStartDate: '',
    incomeVerification: '',
    incomeCriteria: '',
    creditCriteria: '',
    preShowContact: '',
  });

  const { currentUser } = useAuth(); 
  const { loading, error, submitUserQuestionnaire } = useUserOnboarding();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await submitUserQuestionnaire(currentUser.uid, formData);
      alert('Your answers have been saved.');
      navigate('/user-dashboard');
    } catch (err) {
      console.error('Error saving questionnaire:', err);
    }
  };

  return (
    <Box sx={UserQuestionnaireOnboardingStyles.container}>
      <Typography variant="h4" sx={UserQuestionnaireOnboardingStyles.title}>
        Tenant Screening Questionnaire
      </Typography>
      <form onSubmit={handleSubmit} style={UserQuestionnaireOnboardingStyles.form}>
        <FormControl component="fieldset" sx={UserQuestionnaireOnboardingStyles.formControl}>
          <FormLabel component="legend">Are you participating in the Section 8 housing program?</FormLabel>
          <RadioGroup name="section8Participation" value={formData.section8Participation} onChange={handleChange} row>
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
            <FormControlLabel value="maybe" control={<Radio />} label="Might consider it" />
          </RadioGroup>
        </FormControl>

        <TextField
          label="Earliest Lease Start Date"
          type="date"
          name="leaseStartDate"
          value={formData.leaseStartDate}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          fullWidth
          sx={UserQuestionnaireOnboardingStyles.textField}
          required
        />

        <FormControl component="fieldset" sx={UserQuestionnaireOnboardingStyles.formControl}>
          <FormLabel component="legend">
            Are you agreeable with take-home income of 3x the rental amount that can be verified with bank statement deposits?
          </FormLabel>
          <RadioGroup name="incomeVerification" value={formData.incomeVerification} onChange={handleChange} row>
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </FormControl>

        {formData.incomeVerification === 'no' && (
          <TextField
            label="Custom Income Qualifying Criteria"
            name="incomeCriteria"
            value={formData.incomeCriteria}
            onChange={handleChange}
            fullWidth
            sx={UserQuestionnaireOnboardingStyles.textField}
            required
          />
        )}

        <FormControl component="fieldset" sx={UserQuestionnaireOnboardingStyles.formControl}>
          <FormLabel component="legend">What is your credit qualifying criteria?</FormLabel>
          <RadioGroup name="creditCriteria" value={formData.creditCriteria} onChange={handleChange} row>
            <FormControlLabel value="great" control={<Radio />} label="Great (700+)" />
            <FormControlLabel value="good" control={<Radio />} label="Good (600+)" />
            <FormControlLabel value="needsWork" control={<Radio />} label="Needs Work" />
          </RadioGroup>
        </FormControl>

        <FormControl component="fieldset" sx={UserQuestionnaireOnboardingStyles.formControl}>
          <FormLabel component="legend">
            Should tenants with less than good credit contact you before scheduling a showing?
          </FormLabel>
          <RadioGroup name="preShowContact" value={formData.preShowContact} onChange={handleChange} row>
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No, let them discuss during or after" />
          </RadioGroup>
        </FormControl>

        {error && <Typography color="error">{error}</Typography>}

        <Button type="submit" variant="contained" color="primary" sx={UserQuestionnaireOnboardingStyles.submitButton} disabled={loading}>
          {loading ? 'Saving...' : 'Save Answers'}
        </Button>
      </form>
    </Box>
  );
};

export default UserQuestionnaireOnboarding;

